<template>
    <b-modal size="xl" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>Assign Providers & Submit Payments
              <button type="button" class="close" @click.prevent="closeModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </h5>
        </div>
      <b-form>
        <div v-if="generalErrorMessage" class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <p class="ml-2">Assign the participating provider for each fee type and review payment amounts.</p>
        <div class="episode-summary p-4">
          <div class="episode-summary-header">
            Episode Total
            <h5>${{ formatNumber(paymentDistribution.price) }}</h5>
          </div>
          <div class="episode-summary-divide">
          </div>
          <div class="episode-summary-header">
            Total Selected for Payment
            <h5>${{ formatNumber(totalSelectedAmount)}}</h5>
          </div>
          <div class="episode-summary-divide">
          </div>
          <div class="episode-summary-header">
            Balance After Payment
            <h5 :class="{ 'text-danger': balanceAfterPayment < 0 }">${{ formatNumber(balanceAfterPayment) }}</h5>
          </div>
        </div>
        <b-card v-if="step === 1">
        <div class="provider-assignment col-12 py-4">
          <div class="provider-assignment-header col-2">
            INCLUDE
          </div>
          <div class="provider-assignment-header col-4">
            PARTICIPATING PROVIDER
          </div>
          <div class="provider-assignment-header col-3">
            ACCOUNT
          </div>
          <div class="provider-assignment-header col-3 text-right">
            PAYMENT AMOUNT
          </div>
        </div>
        <div class="service-row" v-for="transfer in transfers" :key="transfer.organizationBundleServiceId">
          <div class="provider-assignment-services col-12 pt-3 pb-1">
            <div class="col-2">
              <b-form-checkbox v-model="transfer.includeInPayment"></b-form-checkbox>
            </div>
            <div class="col-4">
              <h6>{{transfer.serviceTypeName}}</h6>
              <b-form-group :state="stateForField('organizationPayeeId_' + transfer.organizationBundlePaymentDistributionServiceId)">
               <b-dropdown menu-class="dropdown-container"
                          id="organizationPayeeId"
                          :text="transfer.payeeName || 'Select Provider'"
                          style="background-color: white"
                          :variant="hasError('organizationPayeeId') ? 'outline-danger' : 'outline-dark'">
                 <b-dropdown-item v-for="payee in payees" :key="payee.organizationPayeeId"
                                 @click.prevent="setPayee(transfer, payee)">{{ payeeDisplayName(payee) }}
                </b-dropdown-item>
              </b-dropdown>
              <div v-if="hasError('organizationPayeeId_' + transfer.organizationBundlePaymentDistributionServiceId)" class="invalid-feedback d-block">
                {{ errorForField('organizationPayeeId_' + transfer.organizationBundlePaymentDistributionServiceId) }}
              </div>
            </b-form-group>
           </div>
            <div class="account-column col-4">
                <b-form-group class="account-name" :state="stateForField('organizationAccountId_' + transfer.organizationBundlePaymentDistributionServiceId)">
                  <div v-if="transfer.accounts && transfer.accounts.length === 1">{{ transfer.accountName }}</div>
              <b-dropdown
                  v-if="transfer.accounts && transfer.accounts.length > 1"
                  menu-class="dropdown-container"
                  id="organizationAccountId"
                  :text="transfer.accountName || 'Select Account'"
                  style="background-color: white"
                  :variant="hasError('organizationAccountId_' + transfer.organizationBundlePaymentDistributionServiceId) ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item
                    v-for="account in transfer.accounts"
                    :key="account.organizationAccountId"
                    @click.prevent="setAccount(transfer, account)">{{ account.name + ' (' + account.last4 + ')'  }}
                </b-dropdown-item>
              </b-dropdown>
                  <div v-if="hasError('organizationAccountId_' + transfer.organizationBundlePaymentDistributionServiceId)"
                      class="invalid-feedback d-block">
                    {{ errorForField('organizationAccountId_' + transfer.organizationBundlePaymentDistributionServiceId) }}
                  </div>
                </b-form-group>
            </div>
            <div class="col-2 text-right">
            <b-form-group
                :state="stateForField('amount_' + transfer.organizationBundlePaymentDistributionServiceId)">
              <b-input-group class="covered-services-amount-input" prepend="$">
                <b-form-input :state="stateForField('amount_' + transfer.organizationBundlePaymentDistributionServiceId)" v-model="transfer.amount"></b-form-input>
              </b-input-group>
              <div v-if="hasError('amount_' + transfer.organizationBundlePaymentDistributionServiceId)"
                   class="invalid-feedback d-block">
                {{ errorForField('amount_' + transfer.organizationBundlePaymentDistributionServiceId) }}
              </div>
            </b-form-group>
            </div>
          </div>
          <div class="prior-container">
            <div class="col-10"></div>
            <div class="col-2 pl-1">
              <div class="pb-3" v-if="transfer.transactions.length">
            <div class="prior-label">PRIOR</div>
            <div v-for="transaction in transfer.transactions"
                 :key="transaction.organizationBundlePaymentDistributionServiceId">
              <div class="previous-transaction">
                <div class="pending mr-2" v-if="transaction.status === 'Pending'"></div>
                <div class="processed mr-2" v-if="transaction.status === 'Processed'"></div>
                <div class="failed-or-cancelled mr-2" v-if="transaction.status === 'Cancelled'"></div>
                <div class="failed-or-cancelled mr-2" v-if="transaction.status === 'Failed'"></div>
                ${{formatNumber(transaction.amount)}} {{transaction.status}}
              </div>
            </div>
              </div>
          </div>
          </div>
        </div>
        </b-card>
        <b-card v-if="step === 2">
          <div class="provider-assignment col-12 py-4">
            <div class="provider-assignment-header col-3">
              PARTICIPATING PROVIDER
            </div>
            <div class="provider-assignment-header col-3">
              ACCOUNT
            </div>
            <div class="provider-assignment-header col-2">
              TAX ID
            </div>
            <div class="provider-assignment-header col-2">
              NPI
            </div>
            <div class="provider-assignment-header col-2 text-right">
              PAYMENT AMOUNT
            </div>
          </div>
          <div v-for="transfer in transfers" :key="transfer.organizationBundleServiceId">
            <div class="row confirm-payment p-4" v-if="transfer.includeInPayment">
              <div class="col-3"><b-form-group :state="stateForField('organizationPayeeId_' + transfer.organizationBundlePaymentDistributionServiceId)" :variant="hasError('organizationPayeeId') ? 'outline-danger' : 'outline-dark'">
                <h6>{{transfer.serviceTypeName}}</h6>
                {{transfer.payeeName}}</b-form-group>
                <div v-if="hasError('organizationPayeeId_' + transfer.organizationBundlePaymentDistributionServiceId)" class="invalid-feedback d-block">
                  {{ errorForField('organizationPayeeId_' + transfer.organizationBundlePaymentDistributionServiceId) }}
                </div></div>
              <div class="col-3"><b-form-group :state="stateForField('organizationAccountId_' + transfer.organizationBundlePaymentDistributionServiceId)" :variant="hasError('organizationAccountId_' + transfer.organizationBundlePaymentDistributionServiceId) ? 'outline-danger' : 'outline-dark'">
                {{transfer.accountName}}</b-form-group>
                <div v-if="hasError('organizationAccountId_' + transfer.organizationBundlePaymentDistributionServiceId)"
                     class="invalid-feedback d-block">
                  {{ errorForField('organizationAccountId_' + transfer.organizationBundlePaymentDistributionServiceId) }}
                </div></div>
              <div class="col-2">
                {{transfer.selectedPayee.taxId}}</div>
              <div class="col-2">
                {{transfer.selectedPayee.npi}}</div>
              <div class="col-2">
               ${{formatNumber(transfer.amount)}}</div>
            </div>
          </div>
          <div class="pt-4">
          <font-awesome-icon size="sm" class="text-warning align-baseline mr-2" icon="exclamation-triangle"/>By submitting payment confirmation, the anchor provider attests covered services rendered are complete and documented.
          </div>
        </b-card>
      </b-form>
      <div slot="modal-footer" class="w-100">
        <button v-if="step === 1" type="button" class="btn btn-orange float-right" @click.prevent="confirmAllPayments()">Confirm All Payments</button>
        <button v-if="step === 2" type="button" class="btn btn-orange float-right" @click.prevent="saveAll()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>Submit All Payments</button>
        <button v-if="step === 2" type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="step--">Back to Edit</button>
        <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
      </div>
    </b-modal>
</template>
<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'

  export default {
    name: 'PayAllDistributionModal',
    mixins: [ErrorsMixin],
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      paymentDistribution: {
        type: Object,
        required: true
      },
      services: {
        type: Array,
        required: false
      }
    },
    data () {
      return {
        transfers: [],
        accounts: [],
        payees: [],
        includeInPayment: false,
        isSaving: false,
        step: 1
      }
    },
    watch: {
      visible (newValue) {
        this.step = 1
        this.clearAllErrors()
        if (newValue) {
          this.transfers = this.services.map(service => {
            const transfer = {
              organizationBundlePaymentDistributionServiceId: service.organizationBundlePaymentDistributionServiceId,
              organizationBundlePaymentDistributionId: service.organizationBundlePaymentDistributionId,
              organizationBundleServiceId: service.organizationBundleServiceId,
              amount: service.totalPaid
                ? Math.max(parseFloat(service.originalAmount) - Math.abs(service.totalPaid), 0).toFixed(2)
                : parseFloat(service.originalAmount).toFixed(2),
              serviceTypeName: service.bundleService.serviceType.name,
              organizationPayeeId: null,
              selectedPayee: null,
              organizationAccountId: null,
              includeInPayment: false,
              payeeName: 'Select Provider',
              accountName: 'Select Account',
              accounts: [],
              transactions: service.transactions
            }
            const defaultPayee = service.bundleService.defaultPayee
            const defaultAccount = service.bundleService.defaultPayeeAccount

            if (defaultPayee) {
              transfer.organizationPayeeId = defaultPayee.organizationPayeeId
              transfer.includeInPayment = !service.transactions.length

              const fullPayee = this.payees.find(p => p.organizationPayeeId === defaultPayee.organizationPayeeId)

              if (fullPayee) {
                transfer.payeeName = this.payeeDisplayName(fullPayee)
                transfer.selectedPayee = fullPayee
                transfer.accounts = fullPayee.accounts

                if (defaultAccount) {
                  transfer.organizationAccountId = defaultAccount.organizationAccountId
                  transfer.accountName = `${defaultAccount.name} (${defaultAccount.last4})`
                } else {
                  transfer.organizationAccountId = null
                  transfer.accountName = 'Select Account'
                }
              }
            }
            return transfer
          })
        }
      }
    },
    computed: {
      totalSelectedAmount () {
        return this.transfers.filter(transfer => transfer.includeInPayment).reduce((sum, transfer) => {
          return sum + (parseFloat(transfer.amount) || 0)
        }, 0)
      },
      balanceAfterPayment () {
        return this.paymentDistribution.availableFunds - this.totalSelectedAmount
      }
    },
    methods: {
      confirmAllPayments () {
        if (this.validate()) {
          this.step++
        }
      },
      validate () {
        this.clearAllErrors()

        const selected = this.transfers.filter(transfer => transfer.includeInPayment)

        if (!selected.length) {
          this.addErrorForField('exception', 'Select at least one service')
        }
        selected.forEach((transfer) => {
          const id = transfer.organizationBundlePaymentDistributionServiceId

          if (!transfer.amount) {
            this.addErrorForField(`amount_${id}`, 'Amount is required')
          }
          if (!transfer.organizationPayeeId) {
            this.addErrorForField(`organizationPayeeId_${id}`, 'Participating Provider is required')
          }
          if (!transfer.organizationAccountId) {
            this.addErrorForField(`organizationAccountId_${id}`, 'Account is required')
          }
        })
        return !this.hasErrors()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },
      loadPayees () {
        api.get('/Dashboard/Payees').then(response => {
          this.payees = response.data.filter(payee => payee.accounts.length > 0)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load payees: ' + error.message, error)
          }
        })
      },
      setPayee (transfer, payee) {
        transfer.organizationPayeeId = payee.organizationPayeeId
        transfer.selectedPayee = payee

        transfer.payeeName = this.payeeDisplayName(payee)
        transfer.includeInPayment = true
        transfer.accounts = payee.accounts

        if (payee.accounts && payee.accounts.length === 1) {
          this.setAccount(transfer, payee.accounts[0])
        } else {
          transfer.accountName = 'Select Account'
          transfer.organizationAccountId = null
        }
      },
      setAccount (transfer, account) {
        transfer.organizationAccountId = account.organizationAccountId
        transfer.accountName = `${account.name} (${account.last4})`
      },

      payeeDisplayName (payee) {
        if (payee.businessName && payee.businessName.trim() !== '') {
          return payee.businessName
        }

        const payeeUser = payee.users?.[0]?.user

        if (!payeeUser) {
          return 'Unknown Provider'
        }

        return `${payeeUser.firstName || ''} ${payeeUser.lastName || ''}`.trim()
      },
      formatNumber (number) {
        const value = Number(number)
        if (!isNaN(value)) {
          return Math.abs(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return '0.00'
      },
      saveAll () {
        if (this.isSaving === true) {
          return
        }
        if (!this.validate()) {
          return
        }
        this.clearAllErrors()
        this.isSaving = true

        const distributionId = this.paymentDistribution.organizationBundlePaymentDistributionId
        const parameters = this.transfers.filter(transfer => transfer && transfer.includeInPayment).map(transfer => ({
          organizationBundlePaymentDistributionServiceId: transfer.organizationBundlePaymentDistributionServiceId,
          amount: parseFloat(transfer.amount),
          organizationAccountId: transfer.organizationAccountId
        }))
        api.post('/Dashboard/PaymentDistribution/' + distributionId + '/PayMultiple', parameters).then(response => {
          this.$emit('payAllSent', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          this.isSaving = false
        })
      }
    },
    created () {
      this.loadPayees()
    }
  }

</script>
<style scoped>
.episode-summary {
  display: flex;
  justify-content: space-between;
  background-color: #f9f9f9;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}
.episode-summary-header {
  color: #2A84F4;
  font-weight:500;
  font-size: 17px;
}
.review-header {
  color: #2A84F4;
  font-weight:500;
  font-size: 17px;
}
.provider-assignment {
  display: flex;
  color: #001859;
  font-weight:500;
}
.provider-assignment-services {
  border-top: 1px solid #dee2e6;
}
.provider-assignment-services:last-child {
  border-bottom: 1px solid #dee2e6;
}
.provider-assignment-services {
  display: flex;
  align-items: center;
}
.covered-services-amount-input {
  padding-top: 27px;
}
.account-column {
  padding-top:  27px;
}
h5 {
  color: #333333;
}
.account-name {
  font-size: 1rem;
}
/deep/ #organizationPayeeId {
  width: 230px;
  text-align: left;
}
/deep/ #organizationPayeeId .dropdown-toggle {
  width: 230px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ #organizationAccountId {
  width: 230px;
  text-align: left;
}
/deep/ #organizationAccountId .dropdown-toggle {
  width: 230px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.episode-summary-divide {
  border: 0.5px solid #dee2e6;
}
.card {
  border: none;
}
.confirm-payment {
  display: flex;
  justify-content: space-between;
  background-color: #f9f9f9;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}
.prior-label {
  color: #737284;
  font-weight: 500;
}
.prior-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.pending {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #BA7517;
}
.processed {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #639922;
}
.failed-or-cancelled {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #B4B2A9;
}
.previous-transaction {
  display: flex;
  align-items: center;
}
.service-row {
  transition: background-color 0.15s ease;
}

.service-row:has(.custom-checkbox input:checked) {
  background-color: #f9f9f9;
}

.service-row:not(:has(.custom-checkbox input:checked)) {
  background-color: #ffffff;
}
</style>
